(() => {
  const STORAGE_KEY = 'dawn-theme-preference';
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const systemTheme = window.matchMedia('(prefers-color-scheme: dark)');

  const getStoredTheme = () => {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (_) {
      return null;
    }
  };

  const setStoredTheme = (theme) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (_) {
      // Privacy mode can deny storage; the visual toggle still works for this visit.
    }
  };

  const updateButtons = (theme, animate) => {
    const isDark = theme === 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach((el) => {
      if (el.type === 'checkbox') {
        /* Suppress the knob slide/colour transition on first paint so there is no flash */
        if (!animate) {
          const sw = el.closest('.switch');
          if (sw) {
            sw.classList.add('switch--no-transition');
            requestAnimationFrame(() =>
              requestAnimationFrame(() => sw.classList.remove('switch--no-transition')),
            );
          }
        }
        el.checked = isDark;
        el.setAttribute('aria-label', document.documentElement.dir === 'rtl' ? (isDark ? 'تبديل إلى الوضع الفاتح' : 'تبديل إلى الوضع الداكن') : (isDark ? 'Switch to light mode' : 'Switch to dark mode'));
      } else {
        el.setAttribute('aria-pressed', String(isDark));
        el.classList.toggle('is-dark', isDark);
      }
    });
  };

  const setTheme = (theme, { persist = true, animate = true } = {}) => {
    root.dataset.theme = theme;
    if (persist) setStoredTheme(theme);

    if (animate && !reducedMotion.matches) {
      root.classList.add('is-theme-transition');
      window.setTimeout(() => root.classList.remove('is-theme-transition'), 450);
    }

    updateButtons(theme, animate);
  };

  const initializeThemeToggle = (el) => {
    if (el.dataset.themeControlReady === 'true') return;
    el.dataset.themeControlReady = 'true';
    if (el.type === 'checkbox') {
      el.addEventListener('change', () => {
        setTheme(el.checked ? 'dark' : 'light');
      });
    } else {
      el.addEventListener('click', () => {
        setTheme(root.dataset.theme === 'dark' ? 'light' : 'dark');
      });
    }
  };

  const initializeLanguageToggle = (button) => {
    if (button.dataset.languageControlReady === 'true') return;
    button.dataset.languageControlReady = 'true';
    button.addEventListener('click', () => {
      const form = button.closest('form');
      const input = form?.querySelector('[data-language-input]');
      if (!form || !input || !button.dataset.languageCode) return;

      input.value = button.dataset.languageCode;
      button.disabled = true;
      root.classList.add('is-language-changing');

      const submit = () => form.submit();
      if (window.gsap && !reducedMotion.matches) {
        window.gsap.to(document.body, {
          autoAlpha: 0,
          y: -4,
          duration: 0.18,
          ease: 'power2.out',
          onComplete: submit,
        });
      } else if (reducedMotion.matches) {
        submit();
      } else {
        window.setTimeout(submit, 140);
      }
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll?.('[data-theme-toggle]').forEach(initializeThemeToggle);
    scope.querySelectorAll?.('[data-language-toggle]').forEach(initializeLanguageToggle);
    updateButtons(root.dataset.theme || 'light', false);
  };

  const defaultMode = root.dataset.themeDefault || 'system';
  systemTheme.addEventListener('change', (event) => {
    if (!getStoredTheme() && defaultMode === 'system') {
      setTheme(event.matches ? 'dark' : 'light', { persist: false });
    }
  });

  document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
